// Display helpers for the material catalog: money (shared with work reports), percentages
// stored as basis points, price units.
export {
  centsToEuro,
  decimalInputProps,
  euroToCents,
  formatDateTime,
  formatEuro,
  formatQuantity
} from "../workReports/format";

const localeOf = lng => ({ de: "de-DE", en: "en-GB", tr: "tr-TR", ar: "ar" })[lng] || "de-DE";

/** 1550 → 15.5 (for an InputNumber in percent) */
export const bpToPercent = bp => Math.round(Number(bp || 0)) / 100;

/** 15.5 → 1550 */
export const percentToBp = percent => Math.round(Number(percent || 0) * 100);

/** 1550 → "15,5 %" */
export const formatPercent = (bp, lng) =>
  `${new Intl.NumberFormat(localeOf(lng), { maximumFractionDigits: 2 }).format(bpToPercent(bp))} %`;

/** A fraction of a cent per unit (millicents) → "0,1125 €" with up to 4 decimals. */
export const formatMillicents = (millicents, lng) =>
  new Intl.NumberFormat(localeOf(lng), {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 4
  }).format(Number(millicents || 0) / 100000);

export const PRICE_UNITS = [1, 10, 100, 1000];

export const KIND_COLORS = { article: "blue", labour: "green", assembly: "purple" };

export const kindLabels = t => ({
  article: t("Article"),
  labour: t("Labour"),
  assembly: t("Assembly")
});

export const textBlockKinds = t => ({
  intro: t("Offer intro"),
  closing: t("Offer closing"),
  position: t("Position text"),
  other: t("Other")
});
